var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabpanel_inner"},[_c(_vm.useComponent,{tag:"component",attrs:{"component_data":_vm.tab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }